import createValidationError from '@/services/functions/create-validation-error';
import updateFormDictonary from './updateFormDictionary';

export default function handleUpdateErrors(error) {
  return createValidationError(updateFormDictonary)(error);
}
